(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-featured-products"] && !Shopify.designMode) return;
  try {
    let cartFeaturedBusy = false;

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-cart-featured-form]');
    if (!form || !window.Shopify?.theme?.ajaxCart) return;
    event.preventDefault();
    if (cartFeaturedBusy) return;

    const config = JSON.parse(document.getElementById('cart-config').textContent);
    const status = form.querySelector('[role="status"]');
    const buttons = document.querySelectorAll('[data-cart-featured-form] button');
    cartFeaturedBusy = true;
    buttons.forEach((button) => { button.disabled = true; });
    form.setAttribute('aria-busy', 'true');
    status.textContent = config.adding_to_cart;
    let added = false;
    let addError = '';

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        addError = result.description || result.message || form.dataset.addError;
      } else {
        added = true;
      }
      const cart = await Shopify.theme.cart.getCart();
      const refreshed = await Shopify.theme.ajaxCart.updateView(config, cart);
      status.textContent = addError || (refreshed ? config.added_to_cart : form.dataset.refreshError);
    } catch (error) {
      status.textContent = addError || (added ? form.dataset.refreshError : form.dataset.addError);
    } finally {
      cartFeaturedBusy = false;
      buttons.forEach((button) => { button.disabled = false; });
      form.removeAttribute('aria-busy');
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snip-product-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-read-more')) {
    customElements.define('product-read-more', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        const content = this.querySelector('[data-description-full]');
        const preview = this.querySelector('[data-description-preview]');
        const toggle = this.querySelector('[data-description-toggle]');
        const limit = Number(this.dataset.initialLength);
        if (!content || !preview || !toggle || !Number.isFinite(limit) || limit < 1) return;
        if (getComputedStyle(content).display === 'none') return;

        const text = content.innerText.replace(/\s+/gu, ' ').trim();
        const characters = Array.from(text);
        if (characters.length <= limit) return;

        let excerpt = characters.slice(0, limit).join('');
        if (!/\s/u.test(characters[limit])) {
          const wordBoundary = excerpt.lastIndexOf(' ');
          if (wordBoundary > 0) excerpt = excerpt.slice(0, wordBoundary);
        }

        preview.textContent = `${excerpt.trimEnd()}…`;
        preview.hidden = false;
        content.hidden = true;
        toggle.hidden = false;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.addEventListener('click', () => {
          const expanded = toggle.getAttribute('aria-expanded') === 'true';
          content.hidden = expanded;
          preview.hidden = !expanded;
          toggle.setAttribute('aria-expanded', String(!expanded));
          toggle.textContent = expanded ? toggle.dataset.readMore : toggle.dataset.readLess;
        });
        this.initialized = true;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snip-product-sticky-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-sticky-cart')) {
    customElements.define('product-sticky-cart', class extends HTMLElement {
      connectedCallback() {
        this.connectionFrame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        this.productSection = this.closest('[data-section-type="product__section"]');
        this.button = this.querySelector('[data-sticky-submit]');
        this.price = this.querySelector('[data-sticky-price]');
        if (!this.productSection || !this.button) return;

        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.schedule = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.update();
          });
        };

        window.addEventListener('scroll', this.schedule, { passive: true, signal });
        window.addEventListener('resize', this.schedule, { passive: true, signal });
        window.visualViewport?.addEventListener('resize', this.schedule, { passive: true, signal });
        window.visualViewport?.addEventListener('scroll', this.schedule, { passive: true, signal });
        document.addEventListener('toggle', this.schedule, { capture: true, signal });
        document.addEventListener('focusin', this.schedule, { signal });
        this.productSection.addEventListener('change', this.schedule, { signal });
        this.productSection.addEventListener('input', this.schedule, { signal });
        document.addEventListener('shopify:block:select', event => {
          if (event.detail.blockId !== this.dataset.blockId) return;
          this.editorSelected = true;
          this.schedule();
        }, { signal });
        document.addEventListener('shopify:block:deselect', event => {
          if (event.detail.blockId !== this.dataset.blockId) return;
          this.editorSelected = false;
          this.schedule();
        }, { signal });

        this.button.addEventListener('click', () => {
          this.update();
          if (!this.originalButton || this.button.disabled) return;
          const invalid = Array.from(this.form.elements).find(field => field.willValidate && !field.validity.valid);
          if (invalid) {
            this.revealField(invalid);
            invalid.reportValidity();
            return;
          }
          this.pendingAdd = true;
          this.originalButton.click();
          const required = Array.from(this.form.elements).find(field => field.classList.contains('required-error'));
          if (required) this.revealField(required);
          this.schedule();
        }, { signal });

        this.observer = new MutationObserver(records => {
          if (records.some(record => !this.contains(record.target) && !record.target.parentElement?.closest('.product__section-images'))) {
            this.schedule();
          }
        });
        this.observer.observe(this.productSection, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['class', 'disabled', 'value', 'style', 'hidden']
        });
        this.bodyObserver = new MutationObserver(this.schedule);
        this.bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
        this.resizeObserver = new ResizeObserver(this.schedule);
        this.resizeObserver.observe(this.productSection);
        this.resizeObserver.observe(this);
        this.update();
      }

      update() {
        this.form = document.getElementById(this.dataset.formId);
        this.originalButton = this.form?.querySelector('.js-ajax-submit');
        const header = document.querySelector('.sticky-header');
        if (header !== this.header) {
          if (this.header) this.resizeObserver.unobserve(this.header);
          this.header = header;
          if (header) this.resizeObserver.observe(header);
        }
        const viewport = window.visualViewport;
        const viewportTop = viewport?.offsetTop || 0;
        const viewportBottom = viewportTop + (viewport?.height || window.innerHeight);
        this.headerBottom = Math.max(viewportTop, header?.getBoundingClientRect().bottom || 0);
        const offset = `${Math.max(0, this.headerBottom)}px`;
        if (this.style.getPropertyValue('--sticky-product-header-bottom') !== offset) {
          this.style.setProperty('--sticky-product-header-bottom', offset);
        }

        if (!this.originalButton || !this.originalButton.getClientRects().length) {
          this.hidden = true;
          return;
        }

        const loading = this.productSection.matches('.is-loading') || Boolean(this.productSection.querySelector('.product__variants-swatches.is-loading, .product__variants-select.is-loading'));
        const label = this.originalButton.value || this.originalButton.textContent.trim();
        if (this.button.textContent !== label) this.button.textContent = label;
        this.button.disabled = this.originalButton.disabled || loading;
        this.button.setAttribute('aria-busy', String(loading || this.originalButton.classList.contains('disabled')));

        if (this.price) {
          const source = this.productSection.querySelector('[data-price]');
          const selector = source?.classList.contains('price--on-sale') ? '.price__sale [data-sale-price]' : '.price__regular [data-regular-price]';
          const value = source?.querySelector(selector)?.textContent.trim();
          this.price.hidden = !value;
          if (value && this.price.textContent !== value) this.price.textContent = value;
        }

        const rect = this.originalButton.getBoundingClientRect();
        const originalVisible = rect.bottom > this.headerBottom && rect.top < viewportBottom && rect.right > 0 && rect.left < window.innerWidth;
        const overlayOpen = document.querySelector('.slideout:popover-open, .modal__container:popover-open, dialog[open], .slideout--active, .modal--active') || document.body.matches('.slideout-left--open, .slideout-right--open, .modal--open');
        const editingField = document.activeElement?.matches('textarea, input:not([type="submit"]):not([type="button"]):not([type="radio"]):not([type="checkbox"]):not([type="hidden"])');
        const keyboardOpen = window.matchMedia('(max-width: 980px)').matches && editingField && viewport && viewport.height < window.innerHeight * 0.8;
        const hide = Boolean(overlayOpen || keyboardOpen || (originalVisible && !this.editorSelected));
        if (hide && originalVisible && this.contains(document.activeElement) && !overlayOpen) {
          this.originalButton.focus({ preventScroll: true });
        }
        this.hidden = hide;

        if (!hide && window.matchMedia('(max-width: 980px)').matches) {
          const space = `${Math.ceil(this.getBoundingClientRect().height)}px`;
          if (document.documentElement.style.getPropertyValue('--sticky-product-cart-space') !== space) {
            document.documentElement.style.setProperty('--sticky-product-cart-space', space);
          }
        }

        if (this.pendingAdd) {
          const error = Array.from(this.form.querySelectorAll('.js-error-msg, .recipient-fields .form__message:not(.hidden)'))
            .find(message => message.getClientRects().length && getComputedStyle(message).visibility !== 'hidden' && message.textContent.trim());
          if (error) {
            const field = error.closest('.recipient-fields__field')?.querySelector('input, textarea') || this.originalButton;
            this.revealField(field, error);
          } else if (overlayOpen || !this.originalButton.disabled) {
            this.pendingAdd = false;
          }
        }
      }

      revealField(field, scrollTarget = field) {
        this.pendingAdd = false;
        field.focus({ preventScroll: true });
        const top = window.scrollY + Math.min(field.getBoundingClientRect().top, scrollTarget.getBoundingClientRect().top) - this.headerBottom - 24;
        window.scrollTo({ top: Math.max(0, top), behavior: 'instant' });
        this.schedule();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.connectionFrame);
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.controller?.abort();
        this.observer?.disconnect();
        this.bodyObserver?.disconnect();
        this.resizeObserver?.disconnect();
        document.documentElement.style.removeProperty('--sticky-product-cart-space');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
